import { render, staticRenderFns } from "./StageLeaderboard.vue?vue&type=template&id=08a65a6f&scoped=true"
import script from "./StageLeaderboard.vue?vue&type=script&lang=js"
export * from "./StageLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./StageLeaderboard.vue?vue&type=style&index=0&id=08a65a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a65a6f",
  null
  
)

export default component.exports